import { FC } from 'react'
import { AvatarInnerBorder } from '@components-v2/atoms/AvatarInnerBorder'
import VerifiedTickSvg from '@/public/images/common/verified-tick_v2.svg'
import styles from './index.module.scss'

type Props = {
  src: string
  alt?: string
  withVerifiedTick?: boolean
}

export const AvatarProfilePhoto: FC<Props> = ({ src, alt = '', withVerifiedTick = false }) => {
  return (
    <div className={styles.container}>
      <div className={styles.avatar}>
        <img src={src} alt={alt} />
        <div className={styles.innerBorder}>
          <AvatarInnerBorder weight='heavy' />
        </div>
      </div>
      {withVerifiedTick && (
        <div className={styles.verifiedTick}>
          <VerifiedTickSvg viewBox='0 0 32 32' />
        </div>
      )}
    </div>
  )
}
